import { useEffect } from 'react';

function useFontmin(text, family) {
  if (family === void 0) {
    family = 'tencent';
  }

  useEffect(function () {
    var fontStyle = document.createElement('style');
    var textNode = document.createTextNode("\n    @font-face {\n        font-family: ".concat(family, ";\n        src: url('https://v.qq.com/x/services/fontmin?font=").concat(family, "&text=").concat(encodeURIComponent(text), "');\n    }"));
    fontStyle.appendChild(textNode);
    document.head.appendChild(fontStyle);
  }, [text, family]);
}

export default useFontmin;